import {ProblemDetailsType} from '@common/types';

export const useProblemDetailsUtils = () => {
  return {
    fromString(detail: string): ProblemDetailsType {
      return {
        status: 0,
        detail: detail,
        title: '',
        instance: '',
        type: '',
      };
    },
  };
};